<div class="edit-posting-form">
  <h3 class="content-card-title">{{translations.textCondition}}</h3>
  <h4 class="content-card-subtitle">{{translations.textApplyVehicle}}</h4>
  <div class="row" [formGroup]="conditionsForm">
    <div class="col-md-12 mb-3">
      <div class="control-wrapper form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" [checked]="isRedLight" class="custom-control-input excludes__input" id="redLight"
            formControlName="redLight" (change)="onRedLightChange($event)"/>
          <div class="tooltip-letter bg-danger text-white" [attr.aria-label]="translations.ariaLabelLearnRedLight">
            <div><span [attr.aria-label]="translations.ariaLabelLearnRedLight">R</span></div>
          </div>
          <label class="custom-control-label excludes__label" for="redLight" [attr.aria-label]="translations.ariaLabelRedLight">
            {{translations.ariaLabelRedLight}}
          </label>
        </div>
      </div>

      <div class="control-wrapper form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input excludes__input" id="yellowLights"
            formControlName="yellowLights" (change)="onYellowLightChange($event)" />
          <div class="tooltip-letter bg-warning">
            <span [attr.aria-label]="translations.ariaLabelLearnYellowLight">Y</span>
          </div>
          <label class="custom-control-label excludes__label" for="yellowLights" [attr.aria-label]="translations.ariaLabelYellowLight">
            {{translations.ariaLabelYellowLight}}
          </label>
        </div>
        @if (isYellowLightChecked) {
          <app-multi-selector-dropdown [list]="yellowLights" [isRequired]="true"
            (checkedList)="checkedListOnChange($event)"
            [multiSelectEnabled]="isMultipleYellowLightsEnabled">
          </app-multi-selector-dropdown>
        }
      </div>

      <div class="control-wrapper form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" [checked]="isNonOperable" class="custom-control-input excludes__input" id="nonOperable"
            formControlName="nonOperable" (change)="onNonOperableLightChange($event)"/>
          <label id="non-operable" class="custom-control-label excludes__label" for="nonOperable" [attr.aria-label]="translations.ariaLabelNonOperable">{{translations.ariaLabelNonOperable}}</label>
        </div>
      </div>

      <div class="d-flex flex-column">
        <div class="form-group mb-0 comment-box">
          <div class="d-flex gap-1 align-items-center additional-condition-disclosures">
            <label class="d-block text-start fw-bold text-black text-uppercase" for="sellerComments">{{translations.labelAdditionalConditionDisclosures}}</label>
            @if (isCanadianTenantEnabled) {
              <button class="border-0 bg-transparent" (click)="sellerDisclosureModal.show()" allytmln="Seller Disclosure Tooltip">
                <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
              </button>
            }
          </div>
          <textarea
            id="sellerComments"
            appCharacterCount
            #comment="appCharacterCount"
            [attr.aria-label]="translations.ariaLabelSellerComments"
            class="form-control mb-1 mt-1"
            rows="3" maxlength="1500"
            (input)="restrictSomeChars()"
            (change)="updateSellerCommentsOnChange()"
            formControlName="sellerComments"
          ></textarea>
          <div class="text-counter">
            <app-character-count
              [count]="comment.count$ | async"
              [maxLength]="1500"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-seller-disclosure-modal></app-seller-disclosure-modal>
